import actionTypes from '../constants/action-types';

const setLastAppliedMigrationId = (lastAppliedMigrationId) => ({
  type: actionTypes.SET_LAST_APPLIED_MIGRATION_ID,
  payload: {
    lastAppliedMigrationId,
  },
});

export default setLastAppliedMigrationId;
